export { ReactComponent as AddSmall } from './svg/add-small.svg';
export { ReactComponent as AlertCaution } from './svg/alert-caution.svg';
export { ReactComponent as AlertError } from './svg/alert-error.svg';
export { ReactComponent as AlertHelp } from './svg/alert-help.svg';
export { ReactComponent as AlertInfo } from './svg/alert-info.svg';
export { ReactComponent as AlertSuccess } from './svg/alert-success.svg';
export { ReactComponent as Android } from './svg/android.svg';
export { ReactComponent as ArrowLeft } from './svg/arrow-left.svg';
export { ReactComponent as ArrowRight } from './svg/arrow-right.svg';
export { ReactComponent as BasicBackgroundCheck } from './svg/basic-background-check.svg';
export { ReactComponent as Boarding } from './svg/boarding.svg';
export { ReactComponent as Calendar } from './svg/calendar.svg';
export { ReactComponent as Call } from './svg/call.svg';
export { ReactComponent as Camera } from './svg/camera.svg';
export { ReactComponent as Cancel } from './svg/cancel.svg';
export { ReactComponent as Car } from './svg/car.svg';
export { ReactComponent as CarouselLeft } from './svg/carousel-left.svg';
export { ReactComponent as CarouselLeftSmall } from './svg/carousel-left-small.svg';
export { ReactComponent as CarouselRight } from './svg/carousel-right.svg';
export { ReactComponent as CarouselRightSmall } from './svg/carousel-right-small.svg';
export { ReactComponent as Cat } from './svg/cat.svg';
export { ReactComponent as ChatInbox } from './svg/chat-inbox.svg';
export { ReactComponent as Check } from './svg/check.svg';
export { ReactComponent as CheckSmall } from './svg/check-small.svg';
export { ReactComponent as CheckCircle } from './svg/check-circle.svg';
export { ReactComponent as CheckCircleOutlined } from './svg/check-circle-outlined.svg';
export { ReactComponent as Cleaning } from './svg/cleaning.svg';
export { ReactComponent as ClearSmall } from './svg/clear-small.svg';
export { ReactComponent as Close } from './svg/close.svg';
export { ReactComponent as CollapseSmall } from './svg/collapse-small.svg';
export { ReactComponent as Copy } from './svg/copy.svg';
export { ReactComponent as CreditCard } from './svg/credit-card.svg';
export { ReactComponent as Daycare } from './svg/daycare.svg';
export { ReactComponent as Dog } from './svg/dog.svg';
export { ReactComponent as DogSizeGiant } from './svg/dog-size-giant.svg';
export { ReactComponent as DogSizeLarge } from './svg/dog-size-large.svg';
export { ReactComponent as DogSizeMedium } from './svg/dog-size-medium.svg';
export { ReactComponent as DogSizeSmall } from './svg/dog-size-small.svg';
export { ReactComponent as Download } from './svg/download.svg';
export { ReactComponent as DropdownSmall } from './svg/dropdown-small.svg';
export { ReactComponent as DropIn } from './svg/drop-in.svg';
export { ReactComponent as Edit } from './svg/edit.svg';
export { ReactComponent as EnhancedBackgroundCheck } from './svg/enhanced-background-check.svg';
export { ReactComponent as ExpandSmall } from './svg/expand-small.svg';
export { ReactComponent as Facebook } from './svg/facebook-redesign.svg';
export { ReactComponent as Favorite } from './svg/favorite.svg';
export { ReactComponent as FavoriteFill } from './svg/favorite-fill.svg';
export { ReactComponent as Filters } from './svg/filters.svg';
export { ReactComponent as Food } from './svg/food.svg';
export { ReactComponent as Gift } from './svg/gift.svg';
export { ReactComponent as Github } from './svg/github.svg';
export { ReactComponent as Google } from './svg/google.svg';
export { ReactComponent as GoogleColor } from './svg/google-color.svg';
export { ReactComponent as Grooming } from './svg/grooming.svg';
export { ReactComponent as Haircut } from './svg/haircut.svg';
export { ReactComponent as Hide } from './svg/hide.svg';
export { ReactComponent as Home } from './svg/home.svg';
export { ReactComponent as InfoSmall } from './svg/info-small.svg';
export { ReactComponent as Instagram } from './svg/instagram-redesign.svg';
export { ReactComponent as IOS } from './svg/ios.svg';
export { ReactComponent as Link } from './svg/link.svg';
export { ReactComponent as List } from './svg/list.svg';
export { ReactComponent as Loading } from './svg/loading.svg';
export { ReactComponent as Map } from './svg/map.svg';
export { ReactComponent as MenuMain } from './svg/menu-main.svg';
export { ReactComponent as MenuMore } from './svg/menu-more.svg';
export { ReactComponent as MenuMoreAlt } from './svg/menu-more-alt.svg';
export { ReactComponent as Minus } from './svg/minus.svg';
export { ReactComponent as Notification } from './svg/notification.svg';
export { ReactComponent as NowBolt } from './svg/now-bolt.svg';
export { ReactComponent as NowBoltFill } from './svg/now-bolt-fill.svg';
export { ReactComponent as Pee } from './svg/pee.svg';
export { ReactComponent as Pets } from './svg/pets.svg';
export { ReactComponent as Pinterest } from './svg/pinterest-redesign.svg';
export { ReactComponent as Plus } from './svg/plus.svg';
export { ReactComponent as Poop } from './svg/poop.svg';
export { ReactComponent as Rebook } from './svg/rebook.svg';
export { ReactComponent as Report } from './svg/report.svg';
export { ReactComponent as ReportAlt } from './svg/report-alt.svg';
export { ReactComponent as Requests } from './svg/requests.svg';
export { ReactComponent as ReviewStar } from './svg/review-star.svg';
export { ReactComponent as ReviewStarFill } from './svg/review-star-fill.svg';
export { ReactComponent as ReviewStarHalf } from './svg/review-star-half.svg';
export { ReactComponent as RightarrowSmall } from './svg/rightarrow-small.svg';
export { ReactComponent as RoverLogo } from './svg/rover-logo.svg';
export { ReactComponent as RxN } from './svg/react-native.svg';
export { ReactComponent as Search } from './svg/search.svg';
export { ReactComponent as Secure } from './svg/secure.svg';
export { ReactComponent as Settings } from './svg/settings.svg';
export { ReactComponent as Share } from './svg/share.svg';
export { ReactComponent as Show } from './svg/show.svg';
export { ReactComponent as Sitting } from './svg/sitting.svg';
export { ReactComponent as Stopwatch } from './svg/stopwatch.svg';
export { ReactComponent as Storybook } from './svg/storybook.svg';
export { ReactComponent as Time } from './svg/time.svg';
export { ReactComponent as Trash } from './svg/trash.svg';
export { ReactComponent as TrustLogo } from './svg/trust-logo.svg';
export { ReactComponent as Twitter } from './svg/twitter-redesign.svg';
export { ReactComponent as Upload } from './svg/upload.svg';
export { ReactComponent as View } from './svg/view.svg';
export { ReactComponent as Walking } from './svg/walking.svg';
export { ReactComponent as Water } from './svg/water.svg';
export { ReactComponent as Web } from './svg/web.svg';
export { ReactComponent as XmarkSmall } from './svg/xmark-small.svg';
export { ReactComponent as TrashSmall } from './svg/trash-small.svg';



// WEBPACK FOOTER //
// ../icons/index.js